export interface ParsedWeightBarcode {
  isWeightBarcode: boolean
  itemCode: string // 5-значный артикул товара
  weightKg: number // вес в килограммах (3 знака после запятой)
  prefix: string
}

/**
 * Парсер магазинных весовых штрихкодов EAN-13 с префиксами 20-29.
 * Формат: [2X][ППППП][ВВВВВ][К]
 * Пример: 2100142014524 → префикс 21, артикул 00142, вес 1452 г = 1.452 кг.
 */
export function parseWeightBarcode(barcode: string): ParsedWeightBarcode | null {
  const clean = barcode.trim()
  // 13 цифр, начинающихся на 20-29.
  const match = clean.match(/^(2[0-9])(\d{5})(\d{5})\d$/)
  if (!match) return null

  const prefix = match[1]
  const itemCode = match[2]
  const grams = parseInt(match[3], 10)
  const weightKg = Number((grams / 1000).toFixed(3))

  return {
    isWeightBarcode: true,
    prefix,
    itemCode,
    weightKg
  }
}
